// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as WalletRepoConfig from "./WalletRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as WalletTransactionStatus from "../entity/WalletTransactionStatus.bs.js";
import * as PartnerWalletRequestEncoder from "./request-encoders/PartnerWalletRequestEncoder.bs.js";

function serializeWalletReportRequest(walletReportRequest) {
  var offsetStr = Belt_Option.map(walletReportRequest.offset, (function (prim) {
          return String(prim);
        }));
  var offset = offsetStr !== undefined ? offsetStr : "";
  var urlParams = {};
  urlParams["till_date"] = DateTime$Catalyst.toString("YYYY-MM-DD", walletReportRequest.tillDate);
  urlParams["offset_value"] = offset;
  var status = walletReportRequest.transactionStatus;
  if (status !== undefined) {
    urlParams["txn_statuses[]"] = WalletTransactionStatus.toString(status);
  }
  return urlParams;
}

function fetchWallet(walletReportRequest, country) {
  var urlParams = serializeWalletReportRequest(walletReportRequest);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/" + (walletReportRequest.msisdn + "/wallet"), urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(WalletRepoConfig.WalletTransactionsResponseConverter.execute, result);
                        });
            });
}

function fetchAdminTransactionReasons(country) {
  var url = Config.Env.getHostName(undefined) + "/administrators/transaction_reasons";
  return NetworkV2$Catalyst.get(url, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(WalletRepoConfig.WalletTransactionReasonsConverter.execute, result);
                        });
            });
}

function createTransaction(msisdn, request, country) {
  var url = $$String.concat("", {
        hd: Config.Env.getHostName(undefined),
        tl: {
          hd: "/administrators/",
          tl: {
            hd: msisdn,
            tl: {
              hd: "/admin_transaction",
              tl: /* [] */0
            }
          }
        }
      });
  var encodedPayload = JSON.stringify(PartnerWalletRequestEncoder.AdminTransactionEncoder.execute(request));
  return Network$Catalyst.postRequestV2(url, encodedPayload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(WalletRepoConfig.AdminTransactionResponseConverter.execute, result);
                        });
            });
}

var WalletRepo = {
  serializeWalletReportRequest: serializeWalletReportRequest,
  fetchWallet: fetchWallet,
  fetchAdminTransactionReasons: fetchAdminTransactionReasons,
  createTransaction: createTransaction
};

export {
  WalletRepo ,
  
}
/* Config Not a pure module */
